import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 1,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 border-b ${scrolled ? 'bg-navy/95 backdrop-blur-md border-steel' : 'bg-transparent border-transparent'}`} data-id="element-95" data-mp="ejnzuv2khkup">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 flex items-center justify-between" data-id="element-96" data-mp="1l1ucpsq2hylx">
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center space-x-3 group" data-id="element-97" data-mp="9qk8c0dvf2tl">
          <Compass className="w-7 h-7 text-gold transition-transform duration-700 group-hover:rotate-45" strokeWidth={1.5} data-id="element-98" data-mp="jmdr41i6nsjt" />
          <span className="font-display text-xl tracking-tight text-cream" data-id="element-99" data-mp="ol8c9a3mht73">
            BPF LLC
          </span>
        </button>

        <div className="hidden md:flex items-center space-x-8 text-[11px] font-semibold tracking-[0.2em] uppercase text-muted" data-id="element-100" data-mp="3n1jare1ltsyq">
          <button onClick={() => scrollTo('identidad')} className="hover:text-cream transition-colors duration-300" data-id="element-101" data-mp="vmbii7lr5wz">
            Identidad
          </button>
          <button onClick={() => scrollTo('filosofia')} className="hover:text-cream transition-colors duration-300" data-id="element-102" data-mp="5oz22xvudmsd">
            Filosofía
          </button>
          <button onClick={() => scrollTo('actividades')} className="hover:text-cream transition-colors duration-300" data-id="element-103" data-mp="39axorggut2wm">
            Actividades
          </button>
          <button onClick={() => scrollTo('jurisdiccion')} className="hover:text-cream transition-colors duration-300" data-id="element-104" data-mp="2wc6mopauihqu">
            Jurisdicción
          </button>
          <button onClick={() => scrollTo('contacto')} className="hover:text-cream transition-colors duration-300" data-id="element-105" data-mp="3b0b8w393xbed">
            Contacto
          </button>
        </div>
      </div>
    </motion.nav>;
}